import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react';
import { useAccount } from '../../../contexts/account/AccountContexts';
import { useTranslation } from 'react-i18next';
import { canShowOnboarding, hideOnboarding } from '../../../services/onboarding/OnboardingService';
import FirstProjectOnboardingContent from './FirstProjectOnboardingContent';

const ENTRY = 'video-tutorial-onboarding';
const VISIBLE_STATE_KEY = 'video-tutorial-onboarding-visible';

const FirstProjectOnboarding: React.FC = () => {
  const { showOnboarding, setShowOnboarding, accountResponse } = useAccount();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [hasEntry, setEntry] = useState(false);

  const isB24Client = accountResponse?.clientType?.toLowerCase() === 'b24';
  const isTrial = accountResponse?.accountStatus === 'TRIAL';

  useEffect(() => {
    if (!isTrial || isB24Client) {
      localStorage.removeItem(VISIBLE_STATE_KEY);
      return;
    }

    const shouldKeepVisible = localStorage.getItem(VISIBLE_STATE_KEY) === '1';
    if (shouldKeepVisible) {
      setVisible(true);
    }

    canShowOnboarding(ENTRY).then((canShow: boolean) => {
      setEntry(!canShow);

      if (canShow || showOnboarding || shouldKeepVisible) {
        localStorage.setItem(VISIBLE_STATE_KEY, '1');
        setVisible(true);
      }
    });
  }, [showOnboarding, accountResponse]);

  const handleClose = () => {
    localStorage.removeItem(VISIBLE_STATE_KEY);

    if (!hasEntry) {
      hideOnboarding(ENTRY).then((isSaved) => {
        setEntry(isSaved);
        hide();
      });
      return;
    }

    hide();
  };

  const hide = () => {
    setVisible(false);
    setShowOnboarding(false);
  };

  if (!isTrial || isB24Client) {
    return null;
  }

  return (
    <Dialog
      visible={visible}
      header={t('firstProjectOnboarding.title')}
      style={{ width: '92vw', maxWidth: '560px' }}
      onHide={handleClose}
      closable={true}
      className="dialog-box dialog-box--video first-project-onboarding-dialog"
    >
      <FirstProjectOnboardingContent onClose={handleClose} />
    </Dialog>
  );
};

export default FirstProjectOnboarding;
